import {
  STATS_TYPES, AGGREGATION_LEVELS,
} from '@/mqtt/liveStats'

const reactionActions = {
  subscribeReactionUpdateAction: async ({ dispatch }, { presentation }) => {
    await dispatch('fetchStatsByWildCardAction', {
      path: `${STATS_TYPES.REACTION_COUNT}/${AGGREGATION_LEVELS.PER_REACTION_TYPE}/${presentation.id}/${presentation.version}`,
    })

    dispatch('subscribeStatsAction', {
      statsType: STATS_TYPES.REACTION_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_REACTION_TYPE,
      identifier: presentation.id,
    })
  },
}

export default reactionActions
